import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue'
import { authModule } from '../../../store'
import { InputIrmao } from '../../../../common/types/Irmao'
import { obrigatorio } from '../../../shareds/regras'
import { intersectRoles } from '../../../helpers/auth-helpers'
import { criarEsposa } from '../../../shareds/sharedsIrmao'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormEsposa',
  props: {
	value: { type: Object as PropType<InputIrmao>, required: true },
},
  emits: ["input"],
  setup(__props, { emit }: { emit: ({
	(e: 'input', irmao: InputIrmao): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const irmao = computed(() => props.value)

function incluirRemoverEsposa() {
	emit('input', {
		...irmao.value,
		esposa: irmao.value.esposa
			? null
			: criarEsposa(),
	})
}

return { __sfc: true,props, emit, irmao, incluirRemoverEsposa, obrigatorio }
}

})